export default "__VITE_ASSET__EKrM7CYB__"